import { PessoaResumoDTO } from "@/types/pessoa";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Person } from "./person"; // Importa nosso ecossistema
import { cn } from "@/lib/utils";
import { PersonNameFormat } from "@/utils/name-format";

interface PersonBadgeProps {
  pessoa: PessoaResumoDTO;
  className?: string;
  label?: string;
  isCompact?: boolean;

  format?: PersonNameFormat;
  isClickable?: boolean;
}

export function PersonBadge({
  pessoa,
  className,
  label,
  isCompact,
  format = "short",
  isClickable = true,
}: Readonly<PersonBadgeProps>) {
  if (!pessoa) return null;

  // Usamos as mesmas regras visuais do seu Tooltip original
  const isExColaborador = !pessoa?.ativo;
  const isAusente = pessoa?.ausente;

  return (
    <Person.Root
      className={cn("w-full max-w-full text-left", className)}
      pessoa={pessoa}
      asClickable={isClickable}
    >
      <Person.Avatar />

      <div className="flex min-w-0 flex-col justify-center gap-1">
        {label && (
          <span className="text-[10px] font-semibold uppercase leading-none tracking-wider text-muted-foreground">
            {label}
          </span>
        )}

        <div className="flex items-center gap-2">
          <Person.Name
            // Se for compact, usamos a utilidade para formatar "Nome I."
            format={format}
            className={cn("text-sm", !isCompact && "max-w-[150px] sm:max-w-[200px]")}
          />
          <Person.Status />
        </div>
      </div>
    </Person.Root>
  );
}
